<template>
  <div v-if="pessoa"
       role="tablist">
    <b-card no-body
            class="cardInfo"
            @submit.prevent="cardChanged(clickDocumentos, 'clickDocumentos')">
      <button v-b-toggle.documentos_collapse
              block
              class="cardInfoBtn"
              type="submit"
              @click="cardChanged(clickDocumentos, 'clickDocumentos')">
        Documentos {{ (pessoa.documentos && pessoa.documentos.length) || deixaBens || deixaTestamento || reservista || eleitorAtivo ? '' : '- Não informado' }}
        <span v-if="(pessoa.documentos && pessoa.documentos.length) || deixaBens || deixaTestamento || reservista || eleitorAtivo">
          <span v-if="!clickDocumentos">
            <icon-svg class="icons--black icon--xxs"
                      icon="arrowRight" />
          </span>
          <span v-else>
            <icon-svg class="icons--black icon--xxs"
                      icon="arrowDown" />
          </span>
        </span>
      </button>

      <b-collapse v-if="clickDocumentos"
                  id="documentos_collapse">
        <div v-if="pessoa"
             class="mt-3 pl-3 pr-3 pb-">
          <div v-for="(documento, index) in pessoa.documentos"
               :key="`${index}-documento`"
               class="row pb-3">
            <div class="col-3">
              <label class="resumo-show_label"
                     for>Documento</label>
              <div
                class="resumo-show_sublabel">
                {{ getDocumentLabel(documento.tipo_documento) || 'Não informado' }}
              </div>
            </div>
            <div class="col-3">
              <label
                class="resumo-show_label"
                for>{{ getDocumentLabel(documento.tipo_documento) || 'Não informado' }}</label>
              <div class="resumo-show_sublabel">
                {{ documento.numero || 'Não informado' }}
              </div>
            </div>
            <div class="col-3">
              <label class="resumo-show_label"
                     for>Estado Expedidor</label>
              <div class="resumo-show_sublabel">
                {{ documento.uf_emissor || 'Não informado' }}
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-2">
              <label class="resumo-show_label"
                     for>Deixa Bens</label>
              <div class="resumo-show_sublabel">
                {{ deixaBens ? 'Sim' : 'Não' }}
              </div>
            </div>
            <div class="col-3">
              <label class="resumo-show_label"
                     for>Deixa Testamento</label>
              <div class="resumo-show_sublabel">
                {{ deixaTestamento ? 'Sim' : 'Não' }}
              </div>
            </div>
            <div class="col-3">
              <label class="resumo-show_label"
                     for>Reservista</label>
              <div class="resumo-show_sublabel">
                {{ reservista ? 'Sim' : 'Não' }}
              </div>
            </div>
            <div class="col-3">
              <label class="resumo-show_label"
                     for>Eleitor Ativo</label>
              <div class="resumo-show_sublabel">
                {{ eleitorAtivo ? 'Sim' : 'Não' }}
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-card>

    <b-card no-body
            class="cardInfo"
            @submit.prevent="cardChanged(clickDeixaFilhos, 'clickDeixaFilhos')">
      <button v-b-toggle.filhos_collapse
              block
              class="cardInfoBtn"
              type="submit"
              @click="cardChanged(clickDeixaFilhos, 'clickDeixaFilhos')">
        Filhos {{ filhoDeixado && filhoDeixado.length && !!deixaFilhos ? '':'- Não informado' }}
        <span v-if="filhoDeixado && filhoDeixado.length && !!deixaFilhos">
          <span v-if="!clickDeixaFilhos">
            <icon-svg class="icons--black icon--xxs"
                      icon="arrowRight" />
          </span>
          <span v-else>
            <icon-svg class="icons--black icon--xxs"
                      icon="arrowDown" />
          </span>
        </span>
      </button>

      <b-collapse v-if="clickDeixaFilhos"
                  id="filhos_collapse">
        <div v-if="!!filhoDeixado.length"
             class="mt-3 pl-2">
          <span>
            Deixa filhos: <br>
            <b>Sim</b>
          </span>
        </div>
        <div v-for="(filho, index) in filhoDeixado"
             :key="`${index}-filho`"
             class="mt-3 pb-2 resumo-show_header--shadow">
          <div class="resumo-show_header--blue">
            {{ index + 1 }}º - {{ filho.nome }}
          </div>
          <div class="pl-3 pb-1 row">
            <div class="col-3">
              <div class="row">
                <div class="col">
                  <label class="resumo-show_header--label">Idade</label>
                  <div class="resumo-show_header--sublabel">
                    <span v-if="filho.idade_tipo != 'I'">
                      {{ filho.idade ? `${filho.idade} ${idade_tipo[filho.idade_tipo]}` : 'Não informada' }}
                    </span>
                    <span v-else>
                      Ignorada
                    </span>
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">Interditado</label>
                  <div class="resumo-show_header--sublabel">
                    {{ filho.interditado ? 'Sim' : 'Não' }}
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">Falecido</label>
                  <div class="resumo-show_header--sublabel">
                    {{ filho.falecido ? 'Sim' : 'Não' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-card>

    <b-card no-body
            class="cardInfo"
            @submit.prevent="cardChanged(clickPartes, 'clickPartes')">
      <button v-b-toggle.declarante_testemunha_collapse
              block
              class="cardInfoBtn"
              type="submit"
              @click="cardChanged(clickPartes, 'clickPartes')">
        Partes {{ (!partes.length) ? '- Não informado' : '' }}
        <span v-if="!!partes.length">
          <span v-if="!clickPartes">
            <icon-svg class="icons--black icon--xxs"
                      icon="arrowRight" />
          </span>
          <span v-else>
            <icon-svg class="icons--black icon--xxs"
                      icon="arrowDown" />
          </span>
        </span>
      </button>

      <b-collapse v-if="clickPartes"
                  id="declarante_testemunha_collapse">
        <div v-for="(parte, index) in partes"
             :key="`${index}-parte`"
             class="resumo-show_header--shadow mt-3">
          <div class="resumo-show_header--blue">
            {{ parte.pessoa.nome || 'Não informado' }}
          </div>
          <div class="pl-3 pb-1 row">
            <div class="col">
              <div class="row">
                <div class="col">
                  <label class="resumo-show_header--label">CPF</label>
                  <div
                    class="resumo-show_header--sublabel">
                    {{ parte.pessoa.cpf || 'Não informado' }}
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">Profissão</label>
                  <div
                    class="resumo-show_header--sublabel">
                    {{ parte.pessoa.ocupacao_declarada || 'Não informado' }}
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">Nacionalidade</label>
                  <div
                    class="resumo-show_header--sublabel">
                    {{ parte.pessoa.nacionalidade ? parte.pessoa.nacionalidade.nome : 'Não informado' }}
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">Estado Civil</label>
                  <div class="resumo-show_header--sublabel">
                    {{ parte.pessoa.estado_civil || 'Não informado' }}
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">RG</label>
                  <div class="resumo-show_header--sublabel">
                    {{ documentoRG(parte.pessoa.documentos) ||'Não informado' }}
                  </div>
                </div>
                <div class="col">
                  <label class="resumo-show_header--label">Endereço Cadastrado</label>
                  <div class="resumo-show_header--sublabel">
                    {{ (parte.pessoa.endereco.logradouro || parte.pessoa.endereco.ibge) ? 'Sim' : 'Não' }} 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
  import { getDocumentLabel } from "@/constants/documentosPessoais"

  export default {
    name: "Third",
    props: [
      "pessoa",
      "deixaFilhos",
      "filhoDeixado",
      "partes",
      "deixaBens",
      "deixaTestamento",
      "reservista",
      "eleitorAtivo"
    ],
    data () {
      return {
        show: false,
        estado_civil: {
          SEPARADO_JUDICIALMENTE: "Separado Judicialmente",
          SOLTEIRO: "Solteiro",
          CASADO: "Casado",
          VIUVO: "Viúvo",
          DIVORCIADO: "Divorciado"
        },
        idade_tipo: {
          I: 'ignorado',
          A: 'anos',
          M: 'meses',
          D: 'dias'
        },
        getDocumentLabel,
        clickDocumentos: false,
        clickDeixaFilhos: false,
        clickPartes: false
      }
    },
    methods: {
      cardChanged (val, name) {
        this[name] = !val
      },
      documentoRG (documentos) {
        const rg = documentos.find(doc => doc.tipo_documento === "RG")

        return rg ? rg.numero : null
      }
    },

  }
</script>

<style lang="scss" scoped>
  .cardInfo {
    padding-top: 15px;
    border-radius: 0;
    border: 0 solid;
  }

  .cardInfoBtn {
    border-radius: 0;
    border: 0 solid;
    background-color: #eaeaea;
    color: #000;
    text-align: left;
    font-size: 1rem;
    font-weight: 500;
    padding: 10px;
    padding-left: 19px;
    margin-bottom: 1px;
  }

  .cardInfoBtn:active,
  .cardInfoBtn:hover {
    outline: 0 !important;
  }
</style>
